/**
 * Extracts a user-friendly error message from an Axios error.
 *
 * Handles three formats:
 *  - Structured object with a message field (e.g. { message: string } or { Message: string })
 *  - Plain string response data
 *  - Network error (no response from server)
 */
export function extractErrorMessage(error) {
  if (!error.response) {
    return "Network error. Please check your connection.";
  }

  const data = error.response.data;

  // Blob responses (from responseType: 'blob') cannot be parsed synchronously.
  if (data instanceof Blob) {
    return error.message || "An unexpected error occurred.";
  }

  if (data && typeof data === "object" && (data.message || data.Message)) {
    return data.message || data.Message;
  }

  if (typeof data === "string" && data.length > 0) {
    return data;
  }

  return error.message || "An unexpected error occurred.";
}
